import Skeleton from '@material-ui/lab/Skeleton'
import React, { CSSProperties, memo } from 'react'

export interface TableLoadingSkeletonProps {
    height: number
    pageSize: number
    customStyles?: CSSProperties
}

const TableLoadingSkeleton = ({
    height,
    pageSize,
    customStyles,
}: TableLoadingSkeletonProps) => {
    return (
        <div
            role="table"
            aria-label="loading data table"
            style={{ ...customStyles }}
        >
            {Array.from(Array(pageSize)).map((_, idx) => (
                <div
                    className="tr spectable-loading"
                    key={`spectable-loading-${idx}`}
                    role="row"
                    aria-label="loading data row"
                >
                    <div role="cell">
                        <Skeleton
                            variant="text"
                            height={height}
                            width={customStyles?.width || '100%'}
                            style={{ zIndex: 100 }}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default memo(TableLoadingSkeleton)
